import Page from 'src/pages/mypage/invitation';

export default Page;
